import { GetStaticPropsContext, NextPage } from 'next'
import Head from 'next/head'
import { GlobalProps, Layout, withLayoutProps } from 'slices/Layout'

import { REVALIDATION_FREQUENCY } from '@/shared/consts'
import { CompareHubSlice } from '@/slices/Compare'

export const getStaticProps = async (context: GetStaticPropsContext) => {
  return withLayoutProps(context, {
    props: {},
    revalidate: REVALIDATION_FREQUENCY,
  })
}

const ComparePage: NextPage<GlobalProps> = (layoutProps) => {
  return (
    <>
      <Head>
        <title>Compare Pixie World to Other Personalized Storybooks | Pixie World</title>
        <meta
          name="description"
          content="See how Pixie World compares to Wonderbly, Hooray Heroes, I See Me!, Story Bug, and Dinkleboo. Full customization, multiple characters, 30+ languages, unlimited stories on one plan."
        />
      </Head>
      <Layout {...layoutProps}>
        <CompareHubSlice />
      </Layout>
    </>
  )
}

export default ComparePage
